export default __webpack_public_path__ + "static/media/A0007.3d034d53.png";